import { z } from 'zod';

export const customFormTimelineRecordSchema = z.object({
  id: z.string(),
  org_id: z.string(),
  property_id: z.string(),
  field_id: z.string().nullish(),
  form_id: z.string(),
  form_version: z.number(),
  location: z.object({ lat: z.number(), lng: z.number() }).nullish(),
  values: z.record(z.unknown()),
  reference_date: z.string().datetime({ offset: true })
});

export const customFormTimelinePageSchema = z.object({
  content: z.array(customFormTimelineRecordSchema),
  last: z.boolean().nullish(),
  cursor: z.string().nullish()
});

export const AgronomicDecisionActionTypeEnum = z.enum(['HANDLE', 'IGNORE', 'NO_HANDLE']);

export const TaskTypeEnum = z.enum(['MONITORING']);

export const SourceEnum = z.enum(['WEB', 'MOBILE']);

const SeverityStatusViewedEnum = z.enum(['CONTROL', 'DAMAGED', 'ACCEPTANCE']);

export const agronomicDecisionResponseSchema = z.object({
  id: z.string(),
  field_id: z.string(),
  start_date: z.string(),
  end_date: z.string(),
  type: TaskTypeEnum,
  user_id: z.string(),
  source: SourceEnum,
  decision: AgronomicDecisionActionTypeEnum,
  comment: z.string().nullable(),
  outdated: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
  deleted_at: z.string().nullable(),
  updated_by: z.string().nullable()
});

export const lastFieldsVisualizationStatusResponseItemSchema = agronomicDecisionResponseSchema.extend({
  content_updated_at: z.string(),
  content_viewed_status: SeverityStatusViewedEnum
});

export const viewersListResponseSchema = z.object({
  [AgronomicDecisionActionTypeEnum.Enum.HANDLE]: z.array(agronomicDecisionResponseSchema.extend({ user_name: z.string() })).optional(),
  [AgronomicDecisionActionTypeEnum.Enum.IGNORE]: z.array(agronomicDecisionResponseSchema.extend({ user_name: z.string() })).optional(),
  [AgronomicDecisionActionTypeEnum.Enum.NO_HANDLE]: z.array(agronomicDecisionResponseSchema.extend({ user_name: z.string() })).optional()
});

export const latestFieldsVisualizationStatusResponseSchema = z.array(lastFieldsVisualizationStatusResponseItemSchema);

export type LatestFieldsVisualizationStatusItem = z.infer<typeof lastFieldsVisualizationStatusResponseItemSchema>;
